module.exports = __webpack_public_path__ + "img/argument_assistant.0cb06cd1.jpg";